import { z } from 'zod';
import { USER_ROLES } from '../constants.js';
import { uuidSchema } from './common.js';
export const loginInputSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(1),
    /** Code TOTP à 6 chiffres. Absent au premier appel : le serveur répond `totpRequired`. */
    totp: z
        .string()
        .regex(/^\d{6}$/, 'Code à 6 chiffres attendu')
        .optional(),
});
export const passwordSchema = z
    .string()
    .min(12, 'Au moins 12 caractères')
    .max(256, 'Au plus 256 caractères');
export const membershipSchema = z.object({
    organizationId: uuidSchema,
    organizationName: z.string(),
    role: z.enum(USER_ROLES),
});
/** Utilisateur courant : ni empreinte de mot de passe, ni secret TOTP. */
export const currentUserSchema = z.object({
    id: uuidSchema,
    email: z.string().email(),
    totpEnabled: z.boolean(),
    memberships: z.array(membershipSchema),
});
export const totpEnrollmentSchema = z.object({
    /** URI otpauth:// à afficher en QR code côté client (généré localement, sans service tiers). */
    otpauthUri: z.string().startsWith('otpauth://'),
    secretBase32: z.string().min(16),
});
export const totpConfirmInputSchema = z.object({
    totp: z.string().regex(/^\d{6}$/, 'Code à 6 chiffres attendu'),
});
export const createOrganizationInputSchema = z.object({
    name: z.string().trim().min(1).max(120),
});
/**
 * Création d'un compte par une administratrice ou un administrateur.
 *
 * Le mot de passe initial est transmis hors bande (pas d'envoi de courriel : Vigie n'a pas de
 * service d'expédition, et en ajouter un supposerait une configuration SMTP dédiée). La personne
 * enrôle son second facteur à sa première connexion, ce qui est obligatoire.
 */
export const createMemberInputSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: passwordSchema,
    role: z.enum(USER_ROLES),
});
export const updateMemberRoleInputSchema = z.object({
    role: z.enum(USER_ROLES),
});
export const changePasswordInputSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
});
//# sourceMappingURL=auth.js.map